
import { Component, Vue, Prop } from "vue-property-decorator";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import image from "@/assets/images/people/person-3.png";
import backgroundImage from "@/assets/images/widgets/background-2.png";
import { SMUser } from "@/store";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class OnExpertReviewCandidateCosAndSwWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Boolean, default: false }) readonly getDependantVisaEnable?: boolean;

  get computedProps() {
    const { jobTitle, name, listType, getDependantVisaEnable } = this;

    return {
      title: this.$tc("title"),
      jobTitle,
      name,
      image,
      backgroundImage,
      listType,
      getDependantVisaEnable,
    };
  }

  get text() {
    const { caseType } = this;
    const role = SMUser.user?.role;

    if (!role) return [];

    const path = `text.${caseType}.${role}`;

    return this.$t(path) || [];
  }
}
